import { useRef } from "react";

export function useSwipe({ onSwipeLeft, onSwipeRight, threshold = 60 } = {}) {
  const start = useRef(null);
  const swiped = useRef(false);
  return {
    swiped,
    handlers: {
      onTouchStart: (e) => {
        const t = e.touches[0];
        start.current = { x: t.clientX, y: t.clientY };
        swiped.current = false;
      },
      onTouchEnd: (e) => {
        if (!start.current) return;
        const t = e.changedTouches[0];
        const dx = t.clientX - start.current.x;
        const dy = t.clientY - start.current.y;
        start.current = null;
        if (Math.abs(dx) > threshold && Math.abs(dx) > Math.abs(dy) * 1.2) {
          swiped.current = true;
          if (dx < 0) onSwipeLeft?.();
          else onSwipeRight?.();
        }
      },
    },
  };
}
